import {
  BreakpointsEnum,
  Link,
  isBreakpointDown,
  useBreakpoint,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {View} from 'native-base';
import React from 'react';

import {StyledScrollView} from 'components/Styled';

export interface TertiaryNav {
  text: string;
  href?: string;
}
export interface TertiaryNavigationProps {
  items: TertiaryNav[];
  activeTab: string;
  onUpdate?: (index: number) => void;
  updateTab: (tabName: string) => void;
}

const TertiaryNavigation: React.FC<TertiaryNavigationProps> = ({
  items,
  activeTab,
  onUpdate,
  updateTab,
}) => {
  const breakpoint = useBreakpoint();
  const isLGOrDown = isBreakpointDown(breakpoint, BreakpointsEnum.LG); // Medium Screens between
  const spacing = isLGOrDown ? 4 : 6;

  const handlePress = (index: number, tabName: string) => {
    onUpdate && onUpdate(index);
    updateTab(tabName);
  };

  return (
    <StyledScrollView
      marginLeft={-spacing}
      horizontal
      showsHorizontalScrollIndicator={false}>
      <View flexDirection="row">
        {items.map((item, index) => (
          <View
            key={index}
            paddingLeft={spacing}
            paddingRight={spacing}
            justifyContent="center"
            height="40px">
            <Link
              testID={item.text}
              analyticsLocation="tertiary-nav"
              href={item.href || ''}
              active={item.text === activeTab}
              onPress={() => handlePress(index, item.text)}
              title={item.text}
              fontSize={isLGOrDown ? 2 : 5}
            />
          </View>
        ))}
      </View>
    </StyledScrollView>
  );
};

export default TertiaryNavigation;
